import React from 'react';
import Nav from '../components/layout/Nav';
import Footer from '../components/layout/Footer';
import '../styles/about.scss';
import { Col, Row, Container, Carousel } from 'react-bootstrap';
// import Image1 from '../assets/other/about-thumb-list1.webp';
import Image1 from '../assets/other/about-thumb-list1.webp';

import Image2 from '../assets/other/about-thumb-list2.webp';
import TestimonialSection from '../components/Testimonials';
import Metrics from '../components/Metrics';
import Partner1 from '../assets/logo/brand-logo1.webp';
import Partner2 from '../assets/logo/brand-logo2.webp';
import Partner3 from '../assets/logo/brand-logo3.webp';
import Partner4 from '../assets/logo/brand-logo4.webp';
import Partner5 from '../assets/logo/brand-logo5.webp';
import WhoWeAre from '../components/WhoWeAre';

const About = () => {
  // Core values data
  const coreValues = [
    {
      icon: '👑',
      title: 'Dignity',
      description: 'Honoring the craft and worth of every artisan we work with',
    },
    {
      icon: '🤝',
      title: 'Trust',
      description:
        'Building reliable, transparent connections between artisans and clients',
    },
    {
      icon: '⭐',
      title: 'Excellence',
      description:
        'Delivering exceptional quality in every project and interaction',
    },
    {
      icon: '💡',
      title: 'Innovation',
      description:
        'Leveraging technology to transform and elevate craftsmanship',
    },
    {
      icon: '❤️',
      title: 'Empathy',
      description:
        'Understanding and addressing the unique needs of artisans and clients',
    },
    {
      icon: '🚀',
      title: 'Empowerment',
      description:
        'Equipping artisans with tools and opportunities to reach their full potential',
    },
  ];

  return (
    <>
      <Nav />
      <section className="about-page-hero">
        <div className="about-page-hero-content">
          <h1>About Us</h1>
          <h6>
            <p>
              <a href="/">Home</a> -{' '}
            </p>{' '}
            About us
          </h6>
        </div>
      </section>
      <WhoWeAre />

      {/* Vision, Mission & Values Section */}
      <section className="vision-mission-section">
        <Container>
          <div className="section-header">
            <h2 className="section-title">Our Vision, Mission & Values</h2>
            <p className="tagline">
              Empowering Kenya's Makers, Inspiring the World
            </p>
            <p className="section-subtitle">
              Driving craftsmanship into the future through technology and
              empowerment
            </p>
          </div>

          {/* Vision, Mission & Values Cards */}
          <Row className="strategy-cards-row">
            <Col lg={4} className="mb-4">
              <div className="strategy-card vision-card">
                <div className="card-icon">
                  <div className="icon-wrapper">
                    <span className="icon">🌍</span>
                  </div>
                </div>
                <div className="card-content">
                  <h3>Our Vision</h3>
                  <p className="card-description">
                    To build Africa's most trusted digital ecosystem that
                    connects and dignifies artisans while transforming how the
                    world experiences craftsmanship.
                  </p>
                  <div
                    className="card-highlight vision"
                  >
                    <span>Building Africa's Digital Craftsmanship Hub</span>
                  </div>
                </div>
              </div>
            </Col>

            <Col lg={4} className="mb-4">
              <div className="strategy-card mission-card">
                <div className="card-icon">
                  <div className="icon-wrapper">
                    <span className="icon">⚡</span>
                  </div>
                </div>
                <div className="card-content">
                  <h3>Our Mission</h3>
                  <p className="card-description">
                    To empower skilled makers through technology, visibility,
                    and fair opportunity, bridging them to clients locally and
                    globally.
                  </p>
                  <div className="card-highlight mission">
                    <span>Empowering Artisans, Connecting Communities</span>
                  </div>
                </div>
              </div>
            </Col>

            <Col lg={4} className="mb-4">
              <div className="strategy-card values-card">
                <Carousel
                  indicators={false}
                  controls={false}
                  interval={3000}
                  pause={false}
                  className="values-inner-carousel"
                >
                  {coreValues.map((value, index) => (
                    <Carousel.Item key={index}>
                      <div className="card-icon">
                        <div className="icon-wrapper">
                          <span className="icon">{value.icon}</span>
                        </div>
                      </div>
                      <div className="card-content">
                        <h3>Our Values</h3>
                        <p className="card-description">{value.description}</p>
                        <div className="card-highlight values">
                          <span>{value.title}</span>
                        </div>
                      </div>
                    </Carousel.Item>
                  ))}
                </Carousel>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="about-page-info container">
        <Row className="about-page-info-content">
          <Col md={6} className="about-page-info-images">
            <img className="image1-about" src={Image1} alt="about 1" />
            <img src={Image2} alt="about 2" />
          </Col>
          <Col md={6} className="about-page-info-text">
            <h6>Why Choose Us</h6>
            <h2>Direct from Artisans, Straight to You</h2>
            <p>
              Artiza is where Kenya's craftsmanship meets technology and trust.
              We connect you directly with verified artisans — from furniture
              makers to electricians — who deliver quality, creativity, and
              reliability in every project.
            </p>
            <p>
              By empowering local makers with fair pay, digital visibility, and
              smart tools like AI and AR, Artiza ensures a transparent, modern,
              and human experience for both artisans and clients. Choose Artiza
              — where every masterpiece has a maker and every maker has a story.
            </p>
          </Col>
        </Row>
      </section>

      <Metrics />
      <TestimonialSection />

      <div className="partners">
        <img src={Partner1} alt="partner 1" />
        <img src={Partner2} alt="partner 2" />
        <img src={Partner3} alt="partner 3" />
        <img src={Partner4} alt="partner 4" />
        <img src={Partner5} alt="partner 5" />
      </div>

      <Footer />
    </>
  );
};

export default About;
